// extracted by mini-css-extract-plugin
export default {"div":"Footer_div__b9uMj","footer":"Footer_footer__kXlYa","slowSpin":"Footer_slowSpin__QJeSm"};